import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import withLocalization from '../hoc/withLocalization';
import { RootState } from '../../redux/rootReducer';
import {
  setPinOptFlowLeadInfo,
  setLeadInfoCheckBox,
  setOfferFlowDetails,
  addOptinPinDetailsRequest,
} from '../../features/OfferValidateContainer/PinOptFlowOfferSlice';
import { logAnalyticData, offerType } from '../../analytics';
import { Offer, OfferResponse } from '../../features/offerSearch/types';
import './LeadInfoDetails.scss';
import { generateCorrelationId, removeDecimalPart } from '../../util/CommonLogic';
import { getSiteIdentifier } from '../../util/SiteDetails';
import { loadOfferDetails } from '../../features/offerSearch/offerSearchSlice';

interface SearchPanelProps {
  localize?: any;
  isValidForm: boolean;
  isEdit: boolean;
  email?: any;
  phone?: any;
  ischecked: boolean;
  leadDetails: any;
  dialCode: any;
}
const LeadSubmitBtn: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { localize, isValidForm, isEdit, email, phone, ischecked, leadDetails, dialCode } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const pinInfoDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  const offerDetails: OfferResponse = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const isSubmitErr = useSelector((state: RootState) => state.offerDetails.hasError);
  const submitError = useSelector((state: RootState) => (isSubmitErr ? state.offerDetails.error?.errorMessageKey : ''));
  const callCenterPhone: any = useSelector((state: RootState) => state.offerDetails.nonFormatedCallcenterNo);
  const mailingData: any = useSelector((state: RootState) => state.newOfferPaymentDetails.mailingAddressInfo);
  const showCTA = useSelector((state: RootState) => state.offerDetails.showCTA);
  const offer: Offer = (offerDetails?.offers && offerDetails.offers[0]) || '';
  const offerCode = offer?.offerCode || 'Vacation Offer';
  const leadInfoDetails: any = useSelector((state: RootState) => state.offerDetails.prospect) || '';
  const siteIdentifier = getSiteIdentifier();
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const urlData: any = useSelector((state: RootState) => state.pinOptFlowDetails.urlData);
  const pin = pinInfoDetails?.pin || '';
  const offerData: Offer = (offerDetails?.offers && offerDetails.offers[0]) || '';
  const roomType: any = (offerData?.roomTypes && offerData?.roomTypes[0]) || {};
  const retailVal = offerData?.retailValue || '';
  const retailPrice = roomType?.highSeasonRetailPrice || '';
  const updatedRetPrice = retailPrice || retailVal;
  const splitRetVal = updatedRetPrice?.split('$') || '';
  const refineRetPrice = removeDecimalPart(splitRetVal[1]) || '';
  const errDetails = {
    errPhNo: callCenterPhone || '',
    isPkgSold: false,
    errorCode: '',
    callCenterCode: leadInfoDetails?.callCenterCode,
    countryName: leadInfoDetails?.countryCode,
  };
  const [handleSubmitPay, setHandleSubmitPay] = useState(false);

  useEffect(() => {
    if (offerDetails?.offers && offerDetails?.offers?.length > 0 && !handleSubmitPay) {
      const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
      navigate('/offer-details' + getUrlSearchParam);
    } else if (offerDetails?.offers && offerDetails?.offers?.length > 0 && handleSubmitPay) {
      const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
      navigate('/payment' + getUrlSearchParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerDetails, handleSubmitPay]);

  const handleClickBackToLandingPage = () => {
    navigate('/pin-error', { state: errDetails });
    window.dataLayer.push({
      event: 'wrong-info',
    });
    logAnalyticData(
      {
        event: 'pbePinWrongInformation',
        siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
        pageName: 'MVC ' + siteIdentifier + 'PBE Verify Page',
        pageHierarchy: '',
        server: 'MVC',
        website: 'MVC react',
        language: 'en',
      },
      {
        errorMessage: 'wrong-info',
        offerCode: offerCode,
        offerType: offerType(offer),
        flowldentifier: 'PIN',
        bookingStepName: 'MVC ' + siteIdentifier + '| PBE Verify Page',
      },
      {
        linkName: 'PBE PIN Wrong Information',
        linkClickPage: 'MVC ' + siteIdentifier + 'PBE Verify Page',
      },
    );
  };
  useEffect(() => {
    if (isSubmitErr || showCTA) {
      navigate('/pin-error', { state: errDetails });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitErr, showCTA]);

  const optinDetailMapping = () => {
    const addr = leadDetails?.addressLine1 ? '' : mailingData?.address;
    const custCity = leadDetails?.city ? '' : mailingData?.city;
    const custZip = leadDetails?.postalCode ? '' : mailingData?.zipCode;
    const custState = leadDetails?.stateProvince ? '' : mailingData?.stateCode;
    const chkFlag = ischecked ? 'Y' : 'N';
    const phoneWithCode = isEdit && phone ? `${dialCode}${phone}` : '';
    const mapData: any = {
      pin: pinInfoDetails?.pin || '',
      optInMail: chkFlag,
      optInEmail: chkFlag,
      optInText: chkFlag,
      optInPhone: chkFlag,
      customerEmail: email || '',
      customerPhone: phoneWithCode || '',
      customerAddress: addr || '',
      customerCity: custCity || '',
      customerState: custState || '',
      customerCountry: '',
      customerZipcode: custZip || '',
    };
    return mapData;
  };
  const analyliticFunc = (adobeEvent: string, adobeStepName: string, googleEvent: string) => {
    const offer: Offer = (offerDetails?.offers && offerDetails.offers[0]) || {};
    const offerCode = offer?.offerCode || 'Vacation Offer';
    const roomType = (offer?.roomTypes && offer?.roomTypes[0]) || {};
    const stateCode = roomType?.property?.stateCode;
    const destination = urlData?.destination;
    const brand = urlData?.brand && urlData?.brand.length > 0 ? urlData?.brand : roomType?.property?.brandName;
    const loc = offer?.loc || '';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: googleEvent,
      ecommerce: {
        items: [
          {
            item_id: roomType?.property?.marshaCode,
            item_name: roomType?.property?.name,
            item_brand: brand,
            item_category: destination,
            item_category2: loc,
            item_category3: roomType?.property?.country || '',
            item_category4: stateCode,
            item_category5: roomType?.property?.city,
            item_category6: '',
            item_category7: offerType(offer),
            item_category8: offerCode,
            item_catagory9: pin,
            price: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
            retail_price: refineRetPrice?.replace(/[$,]/g, '') || '',
            package_price: roomType?.startingCost?.replace(/[$,]/g, '') || '',
            flow_identifier: 'pin',
            quantity: 1,
          },
        ],
      },
    });
    logAnalyticData(
      {
        event: adobeEvent,
        siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
        pageName: 'MVC ' + siteIdentifier + 'PBE PIN OfferPage',
        pageHierarchy: '',
        server: 'MVC',
        website: 'MVC react',
        language: 'en',
      },
      {
        errorMessage: submitError,
        offerCode: offerCode,
        offerType: offerType(offer),
        flowIdentifier: 'PIN',
        formLOC: loc,
        destination: destination,
        resortCity: roomType?.property?.city,
        resortState: roomType?.property?.stateCode,
        resortCountry: roomType?.property?.country || '',
        resortName: roomType?.property?.name,
        resortBrand: brand,
        retail_price: refineRetPrice?.replace(/[$,]/g, '') || '',
        packagePrice: roomType?.startingCost?.replace(/[$,]/g, '') || '',
        depositPrice: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
        currency: 'USD',
        quanity: '1',
        resortMarsha: roomType?.property?.marshaCode,
        userSelectedState: prospectDetails?.stateProvince,
        bookingStepName: adobeStepName,
      },
    );
  };
  const handlePayClick = () => {
    analyliticFunc('pbePinBeginCheckout', 'MVC ' + siteIdentifier + '| PBE PIN Begin Checkout', 'begin_checkout');
  };
  const handleClickLeadSubmitBtn = () => {
    if (isValidForm) {
      const searchParams = new URLSearchParams(location.search);
      let efcValue: any;

      // Case-insensitive search for 'efc'
      for (let [key, value] of searchParams.entries()) {
        if (key.toLowerCase() === 'efc') {
          efcValue = value;
          break;
        }
      }

      sessionStorage.setItem('effortCodeParam', efcValue);
      const correlationId = generateCorrelationId();
      const optinPayload = optinDetailMapping();
      dispatch(addOptinPinDetailsRequest({ ...optinPayload, correlationId }, correlationId));
      if (isEdit) {
        dispatch(setPinOptFlowLeadInfo({ email, phone, dialCode }));
      } else {
        dispatch(setPinOptFlowLeadInfo({ email: '', phone: '', dialCode }));
      }
      dispatch(setOfferFlowDetails(true));
      dispatch(setLeadInfoCheckBox(ischecked));
      dispatch(loadOfferDetails(pinInfoDetails?.pin, pinInfoDetails?.lastName, 'y', true));
      setHandleSubmitPay(true);
      handlePayClick();
      window.dataLayer.push({
        event: 'pin-verify',
      });
      logAnalyticData(
        {
          event: 'pbePinVerify',
          siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
          pageName: 'MVC ' + siteIdentifier + 'PBE Verify Page',
          pageHierarchy: '',
          server: 'MVC',
          website: 'MVC react',
          language: 'en',
        },
        {
          errorMessage: submitError,
          offerCode: offerCode,
          offerType: offerType(offer),
          flowldentifier: 'PIN',
          bookingStepName: 'MVC ' + siteIdentifier + '| PBE Verify Page',
        },
        {
          linkName: 'PBE PIN Verify',
          linkClickPage: 'MVC ' + siteIdentifier + 'PBE Verify Page',
        },
      );
    }
  };

  return (
    <>
      <div className="leadInfo-btn-container">
        <button
          className={isValidForm ? 'myInfo-btn-enable' : 'myInfo-btn-disable'}
          onClick={() => handleClickLeadSubmitBtn()}
        >
          {localize('preview-sales-engine.static-content.copy.pbeo.yes-my-info-cta-label')}
        </button>
        <button className="notMyInfo-btn" onClick={() => handleClickBackToLandingPage()}>
          {localize('preview-sales-engine.static-content.copy.pbeo.not-my-info-cta-label')}
        </button>
      </div>
    </>
  );
};
export default withLocalization(LeadSubmitBtn);
